import Vue from 'vue'
import Router from 'vue-router'
import PositionList from '../components/PositionList2022.vue'
import Position from '../components/Position.vue'
import Delivery from "../components/Delivery";
import DeliveryList from "../components/DeliveryList";
import Resume from "../components/Resume";
import Process from "../components/Process";
import NoLogin from "../components/NoLogin";
import QA from "../components/QA2027";
import Intro from "../components/Intro";
import Index from "../components/Index2027";
import MiniOauthRedirect from "../components/MiniOauthRedirect";
import Msg from "../components/Msg";
import InterviewBooking from "../components/InterviewBooking";


Vue.use(Router)

export default new Router({
    //mode: 'history',  //去掉url中的#
    routes: [
        {
            path: '/',
            redirect:'/index'
        },
        {
            path: '/index',
            component: Index,
            meta: {
                title: '汽车之家招聘-校园招聘',
            },
        },
        {
            path: '/positionlist',
            component: PositionList,
            meta: {
                title: '汽车之家招聘-校园招聘',
            },
        },
        {
            path: '/position',
            component: Position,
            meta: {
                title: '职位详情',
            },
        },
        {
            path: '/delivery',
            component: Delivery,
            meta: {
                title: '简历投递',
            },
        },
        {
            path: '/deliverylist',
            component: DeliveryList,
            meta: {
                title: '应聘记录',
            },
        },
        {
            path: '/resume',
            component: Resume,
            meta: {
                title: '我的简历',
            },
        },
        {
            path: '/process',
            component: Process,
            meta: {
                title: '应聘进度',
            },
        },
        {
            path: '/nologin',
            component: NoLogin,
            meta: {
                title: '请登录',
            },
        },
        {
            path: '/qa',
            component: QA,
            meta: {
                title: '招聘动态',
            },
        },
        {
            path: '/intro',
            component: Intro,
            meta: {
                title: '管培生计划',
            },
        },

        {
            path:'/msg',
            component:Msg,
            meta: {
                title: '面试通知',
            },
        },

        {
            path:'/interview',
            component:InterviewBooking,
            meta: {
                title: '预约面试时间',
            },
        },

        {
            path:'/minioauthredirect',
            component:MiniOauthRedirect,
            meta: {
                title: '校招登录',
            },
        }
    ],


})

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
    return originalPush.call(this, location).catch(err => err)
}
